module.exports = __webpack_public_path__ + "img/img47.1872dd62.jpg";